import { map } from 'rxjs/operators';
import { Store } from '@ngrx/store';
import { Injectable } from '@angular/core';
import { HttpClient } from '@angular/common/http';
import { Observable } from 'rxjs';
import { FarmCadastralSheet } from '../_models/farmCadastralSheet';
import { environment } from '../../../environments/environment';
import { AppState } from '../_reducers';

@Injectable()
export class FarmCadastralSheetService {
  private apiBaseUrl = environment.apiBaseUrl;
  farmCadastralSheetList$: Observable<FarmCadastralSheet[]>;

  constructor(
    private http: HttpClient,
    private store: Store<AppState>
  ) {
    //this.farmCadastralSheetList$ = store.select('farmCadastralSheets');
  }

  getFromLocalStore(): Observable<FarmCadastralSheet[]> {
    return this.farmCadastralSheetList$;
  }

  getFarmCadastralSheets(): Observable<FarmCadastralSheet[]> {
    return this.http
      .get<FarmCadastralSheet[]>(this.apiBaseUrl + 'api/private/v1/farmCadastralSheets')
      .pipe(map((response) => response));
  }
  getFarmCadastralSheet(id: number): Observable<FarmCadastralSheet> {
    return this.http
      .get<FarmCadastralSheet>(this.apiBaseUrl + 'api/private/v1/farmCadastralSheets/' + id)
      .pipe(map((response) => response));
  }
  saveFarmCadastralSheet(farmCadastralSheet): Observable<FarmCadastralSheet> {
    delete farmCadastralSheet.lastUpdated;
    delete farmCadastralSheet.dateCreated;

    if (farmCadastralSheet.farm) {
      const idfarm: any = {
        id: farmCadastralSheet.farm.id,
      };

      farmCadastralSheet.farm = idfarm;
    }

    const companySelected = JSON.parse(localStorage.getItem('companySelected'));
    farmCadastralSheet.companyId = companySelected ? companySelected.id : null;

    if (farmCadastralSheet.id) {
      return this.http
        .put<FarmCadastralSheet>(
          this.apiBaseUrl + 'api/private/v1/farmCadastralSheets/' + farmCadastralSheet.id,
          farmCadastralSheet
        )
        .pipe(map((response) => response));
    } else {
      return this.http
        .post<FarmCadastralSheet>(
          this.apiBaseUrl + 'api/private/v1/farmCadastralSheets/',
          farmCadastralSheet
        )
        .pipe(map((response) => response));
    }
  }
  deleteFarmCadastralSheet(id: number): Observable<FarmCadastralSheet> {
    return this.http.delete(this.apiBaseUrl + 'api/private/v1/farmCadastralSheets/' + id).pipe(
      map((response) => {
        const deleted = new FarmCadastralSheet();
        deleted.id = id;
        return deleted;
      })
    );
  }
}
